import { render } from "./intGrants.vue?vue&type=template&id=67300c20&scoped=true"
import script from "./intGrants.vue?vue&type=script&lang=js"
export * from "./intGrants.vue?vue&type=script&lang=js"

import "./intGrants.vue?vue&type=style&index=0&id=67300c20&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67300c20"]])

export default __exports__